import { ACHIEVEMENTS, xpToLevel } from "./gamification";

export const DEMO_LEARNER_ID = 900001;

const DEMO_NOW = new Date();
const daysAgo = (days) => {
  const date = new Date(DEMO_NOW);
  date.setDate(date.getDate() - days);
  return date.toISOString();
};

const DEMO_LEARNERS = [
  {
    messengerId: DEMO_LEARNER_ID,
    displayName: "Анна Петрова (пример)",
    username: "anna_demo",
    rank: 1,
    xp: 420,
    level: xpToLevel(420),
    totalCompletions: 7,
    totalCorrect: 38,
    totalAnswers: 42,
    bestAccuracy: 100,
    currentStreak: 4,
    longestStreak: 7,
  },
  {
    messengerId: 900002,
    displayName: "Иван Сидоров (пример)",
    username: "ivan_demo",
    rank: 2,
    xp: 310,
    level: xpToLevel(310),
    totalCompletions: 5,
    totalCorrect: 24,
    totalAnswers: 30,
    bestAccuracy: 92,
  },
  {
    messengerId: 900003,
    displayName: "Мария Козлова (пример)",
    username: "maria_demo",
    rank: 3,
    xp: 180,
    level: xpToLevel(180),
    totalCompletions: 3,
    totalCorrect: 14,
    totalAnswers: 18,
    bestAccuracy: 88,
  },
];

const DEMO_ACHIEVEMENT_STATS = {
  first_completion: 3,
  perfect_score: 1,
  five_sessions: 2,
  ten_sessions: 0,
  streak_3: 2,
  streak_7: 1,
  streak_30: 0,
  explorer: 1,
  path_master: 1,
};

const DEMO_UNLOCKED = {
  first_completion: daysAgo(14),
  perfect_score: daysAgo(5),
  five_sessions: daysAgo(3),
  streak_3: daysAgo(2),
  explorer: daysAgo(10),
};

const DEMO_SESSIONS = [
  {
    sessionId: "demo-session-1",
    gameId: "demo-game-1",
    projectTitle: "Онбординг нового сотрудника",
    contentType: "scenario",
    contentTypeLabel: "Сценарий",
    startedAt: daysAgo(2),
    completedAt: daysAgo(2),
    completed: true,
    correctCount: 8,
    totalAnswers: 10,
    accuracy: 80,
    resultLabel: "8/10 (80%)",
    path: [],
    droppedAtScene: null,
  },
  {
    sessionId: "demo-session-2",
    gameId: "demo-game-2",
    projectTitle: "Продажи: работа с возражениями",
    contentType: "trainer",
    contentTypeLabel: "Тренажёр",
    startedAt: daysAgo(5),
    completedAt: daysAgo(5),
    completed: true,
    correctCount: 12,
    totalAnswers: 12,
    accuracy: 100,
    resultLabel: "12/12 (100%)",
    path: [],
    droppedAtScene: null,
  },
  {
    sessionId: "demo-session-3",
    gameId: "demo-game-3",
    projectTitle: "Регламент компании",
    contentType: "knowledge_base",
    contentTypeLabel: "База знаний",
    startedAt: daysAgo(9),
    completedAt: daysAgo(9),
    completed: true,
    correctCount: 0,
    totalAnswers: 0,
    accuracy: null,
    resultLabel: "Завершено",
    path: [],
    droppedAtScene: null,
  },
];

const DEMO_PROFILES = {
  [DEMO_LEARNER_ID]: {
    learner: {
      messengerId: DEMO_LEARNER_ID,
      displayName: "Анна Петрова (пример)",
      username: "anna_demo",
      rank: 1,
      xp: 420,
      level: xpToLevel(420),
      currentStreak: 4,
      longestStreak: 7,
      totalCompletions: 7,
      totalCorrect: 38,
      totalAnswers: 42,
      bestAccuracy: 100,
      completedProjects: 3,
      contentTypesCompleted: ["scenario", "trainer", "knowledge_base"],
    },
    sessions: DEMO_SESSIONS,
    achievements: ACHIEVEMENTS.map((item) => ({
      ...item,
      unlocked: Boolean(DEMO_UNLOCKED[item.id]),
      unlockedAt: DEMO_UNLOCKED[item.id] ?? null,
    })),
    unlockedCount: Object.keys(DEMO_UNLOCKED).length,
  },
  900002: {
    learner: {
      messengerId: 900002,
      displayName: "Иван Сидоров (пример)",
      username: "ivan_demo",
      rank: 2,
      xp: 310,
      level: xpToLevel(310),
      currentStreak: 2,
      longestStreak: 4,
      totalCompletions: 5,
      totalCorrect: 24,
      totalAnswers: 30,
      bestAccuracy: 92,
      completedProjects: 2,
      contentTypesCompleted: ["scenario", "trainer"],
    },
    sessions: DEMO_SESSIONS.slice(0, 2).map((session, index) => ({
      ...session,
      sessionId: `demo-session-ivan-${index + 1}`,
    })),
    achievements: ACHIEVEMENTS.map((item) => ({
      ...item,
      unlocked: ["first_completion", "five_sessions"].includes(item.id),
      unlockedAt:
        item.id === "first_completion"
          ? daysAgo(12)
          : item.id === "five_sessions"
            ? daysAgo(4)
            : null,
    })),
    unlockedCount: 2,
  },
  900003: {
    learner: {
      messengerId: 900003,
      displayName: "Мария Козлова (пример)",
      username: "maria_demo",
      rank: 3,
      xp: 180,
      level: xpToLevel(180),
      currentStreak: 0,
      longestStreak: 2,
      totalCompletions: 3,
      totalCorrect: 14,
      totalAnswers: 18,
      bestAccuracy: 88,
      completedProjects: 1,
      contentTypesCompleted: ["scenario"],
    },
    sessions: [DEMO_SESSIONS[0]].map((session) => ({
      ...session,
      sessionId: "demo-session-maria-1",
    })),
    achievements: ACHIEVEMENTS.map((item) => ({
      ...item,
      unlocked: item.id === "first_completion",
      unlockedAt: item.id === "first_completion" ? daysAgo(8) : null,
    })),
    unlockedCount: 1,
  },
};

export function getDemoLearnerProfile(messengerId) {
  return DEMO_PROFILES[Number(messengerId)] ?? null;
}

export function getRatingDemoView() {
  const month = DEMO_NOW.toISOString().slice(0, 7);

  return {
    isDemo: true,
    demoLabel: "Пример данных",
    data: {
      leaderboard: DEMO_LEARNERS,
      achievementStats: DEMO_ACHIEVEMENT_STATS,
      totals: {
        learners: DEMO_LEARNERS.length,
        completions: DEMO_LEARNERS.reduce(
          (sum, item) => sum + (item.totalCompletions ?? 0),
          0
        ),
      },
      monthlyChallenge: {
        month,
        targetCompletions: 5,
        leaders: [
          {
            messengerId: DEMO_LEARNER_ID,
            completions: 4,
            reachedTarget: false,
          },
          {
            messengerId: 900002,
            completions: 5,
            reachedTarget: true,
          },
        ],
      },
    },
    learners: DEMO_LEARNERS,
    defaultLearnerId: String(DEMO_LEARNER_ID),
  };
}

export function isDemoLearnerId(messengerId) {
  return [900001, 900002, 900003].includes(Number(messengerId));
}
